// eslint-disable-next-line no-unused-vars
import { Card, Col } from "antd";
import React, { memo } from "react";
import { ReactComponent as Logo } from "../../../assets/images/logo.svg";
import moment from "moment";

// eslint-disable-next-line no-unused-vars
const PrintMeritList = ({ exam, meritlist }) => {
  // console.log('liveExam', liveExam,  studentProfile, examResult);
  const timeTaken = (startsAt, submittedAt) => {
    if (startsAt && submittedAt) {
      const submitMoment = moment(submittedAt);
      const startMoment = moment(startsAt);

      // Getting the difference: hours (h), minutes (m) and seconds (s)
      let h = submitMoment.diff(startMoment, "hours");
      let m = submitMoment.diff(startMoment, "minutes") - 60 * h;
      let s = submitMoment.diff(startMoment, "seconds") - 60 * 60 * h - 60 * m;

      // Formating in hh:mm:ss (appends a left zero when num < 10)
      let hh = ("0" + h).slice(-2);
      let mm = ("0" + m).slice(-2);
      let ss = ("0" + s).slice(-2);

      return `${hh}:${mm}:${ss}`;
    }
    return 0;
  };
  return (
    <div className="merit-wrapper">
      <div className="logo-section" style={{ textAlign: "center" }}>
        <Logo />
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          marginBottom: "20px",
        }}
      >
        <div style={{ textTransform: "uppercase", fontSize: "30px" }}>
          Progress Report
        </div>
      </div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "20px",
          marginBottom: "20px",
          justifyContent: "space-between",
          border: "1px solid black",
          padding: "5px",
        }}
      >
        {/* <div style={{display:'flex',flexDirection:'column',gap:'10px',flex:'1'}}>
                                <div>Total Marks: {liveExam?.totalMarks}</div>
                                <div>Total Marks Obtained: {liveExam?.totalMarksObtained}</div>
                            </div>
                            <div style={{display:'flex',flexDirection:'column',gap:'10px',flex:'1'}}>
                                <div>Total Exams: {liveExam?.totalExamCount ?? liveExam?.count}</div>
                                <div>Average Marks: {Number(liveExam?.averageMarkObtained).toFixed(2)}</div>
                            </div>
                            <div style={{display:'flex',flexDirection:'column',gap:'10px',flex:'1'}}>
                                <div>Highest Marks: {liveExam?.maxMarkObtained}</div>
                                
                            </div> */}
      </div>
      <table className="">
        <thead>
          <tr>
            <th>Name</th>
            <th>Subject</th>
            <th>Total Obtained Marks</th>
            <th>Negative Marks</th>
            <th>Total Wrong Answer</th>
            <th>Overall Position</th>
            <th>Faculty Position</th>
            <th>Subject Position</th>
            <th>Govt, Non-Govt, AMC & Other Position</th>
            <th>Completion</th>
          </tr>
        </thead>
        <tbody>
          {meritlist?.map((item, index) => {
            return (
              <tr key={index}>
                <td>{item?.studentId?.name}</td>
                <td>{item?.subjectName}</td>
                <td>{item?.marksObtained}</td>
                <td>{item?.negativeMarks}</td>
                <td>{item?.totalWrongAnswer}</td>
                <td>{item?.rank}</td>
                <td>{item?.facultyPosition}</td>
                <td>{item?.subjectPosition}</td>
                <td>{item?.categoryPosition}</td>
                <td>
                  {item?.startsAt && item?.submittedAt
                    ? timeTaken(item?.startsAt, item?.submittedAt)
                    : ""}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default memo(PrintMeritList);
